<template>
  <div>
    <b-modal
      size="lg"
      id="create"
      title="NOVO PEDIDO"
      hide-footer
      no-close-on-backdrop
    >
      <create :resident="resident" @success="paginate" />
    </b-modal>
    <b-modal
      title="DETALHES DO PEDIDO"
      id="details"
      size="lg"
      hide-footer
      no-close-on-backdrop
    >
      <details-order :order="order" />
    </b-modal>
    <b-modal
      title="EDITAR PEDIDO"
      id="edit"
      size="lg"
      hide-footer
      no-close-on-backdrop
    >
      <edit :order="order" :resident="resident" @success="paginate" />
    </b-modal>
    <b-modal id="filter" no-close-on-backdrop hide-footer title="FILTRAR">
      <div class="row">
        <div class="col-md-12">
          <select v-model="status" class="form-control">
            <option value="1">ATIVO</option>
            <option value="0">INATIVO</option>
          </select>
        </div>
        <div class="col-md-12 pt-0 pb-0">
          <ErrorsMessages :errors="errors" />
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-right">
          <v-btn @click="handleFilter" class="btn-filter" type="relief">
            <i class="fas fa-filter mr-2 text-twenty"></i>
            FILTRAR
          </v-btn>
        </div>
      </div>
    </b-modal>
    <div class="row">
      <div class="col-md-12 text-right">
        <v-btn
          @click="$bvModal.show('filter')"
          class="btn-filter mr-2"
          type="relief"
        >
          <i class="fas fa-filter mr-2 text-twenty"></i> FILTRAR
        </v-btn>
        <v-btn
          v-if="permission('write', 'resident_has_order')"
          @click="$bvModal.show('create')"
          class="btn-two-add"
        >
          <i class="fas fa-plus mr-2 text-twenty"></i>NOVO PEDIDO
        </v-btn>
      </div>
      <div class="col-md-12">
        <b-overlay :show="loading" opacity="0.99">
          <div v-show="data.length === 0" class="v-clean p-5">
            <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
          </div>
          <v-data-table
            v-show="data.length > 0"
            dense
            :headers="headers"
            :items="data"
            :footer-props="{
              'items-per-page-options': [50, 75, 100],
              'items-per-page-text': 'Mostrar',
            }"
            :options.sync="options"
            :server-items-length="total"
          >
            <template v-slot:[`item.status`]="{ item }">
              <span v-if="item.status == 1" class="c-success">ATIVO</span>
              <span v-else class="c-danger">INATIVO</span>
            </template>
            <template v-slot:[`item.text`]="{ item }">
              {{ item.text }}
            </template>
            <template v-slot:[`item.created_at`]="{ item }">
              {{ moment(item.created_at).format("DD/MM/YYYY HH:mm:ss") }}
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn small class="btn-primary m-1" @click="handleDetails(item)">
                <i class="fas fa-eye mr-2"></i>DETALHES
              </v-btn>
              <v-btn
                small
                v-if="permission('edit', 'resident_has_order')"
                class="btn-edit m-1"
                @click="handleEdit(item)"
              >
                <i class="fas fa-edit mr-2"></i>EDITAR
              </v-btn>
              <confirmation-dialog
                v-if="
                  permission('remove', 'resident_has_order') &&
                  !item.data_base64
                "
                small
                message-title="EXCLUIR?"
                message-body="Deseja realmente excluir?"
                open-class="btn-delete m-1"
                open-left-icon="fa-trash"
                open-text="EXCLUIR"
                @yes="deleteOrder(item.id)"
              />
              <v-btn small class="btn-print m-1" @click="handlePrint(item)">
                <i class="fas fa-print mr-2"></i>IMPRIMIR
              </v-btn>
              <ButtonGenerateCertificate
                v-if="item.data_base64"
                :id="item.id"
                :data_base64="item.data_base64"
                :modal_id="item.id"
              />
            </template>
          </v-data-table>
        </b-overlay>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../Components/ErrorsMessages.vue";

import ConfirmationDialog from "../../Components/ConfirmationDialog.vue";

import ButtonGenerateCertificate from "../../Components/ButtonGenerateCertificate.vue";

import Create from "./order/create.vue";
import DetailsOrder from "./order/details.vue";
import Edit from "./order/edit.vue";

import api from "../../../services/api";

import toast from "../../../lib/ToastNotification";

import routes from "../../../routes";

import {
  professionalClassCouncilValue,
  formatPrice,
} from "../../../lib/format";

import moment from "moment";

import permission from "../../../lib/permission";

export default {
  name: "Order",

  components: {
    ErrorsMessages,
    ConfirmationDialog,
    ButtonGenerateCertificate,
    Create,
    DetailsOrder,
    Edit,
  },

  props: {
    resident: Object,
  },

  data() {
    return {
      status: 1,

      resident_id: "",

      total: 0,
      options: {},

      headers: [
        { text: "STATUS", value: "status", sortable: false },
        { text: "TÍTULO", value: "title", sortable: false },
        { text: "TEXTO", value: "text", sortable: false },
        { text: "DATA REGISTRO", value: "created_at", sortable: false },
        { text: "AÇÕES", value: "actions", sortable: false, align: "end" },
      ],

      data: [],

      order: {},

      loading: false,

      errors: [],
    };
  },

  watch: {
    options: {
      handler() {
        this.paginate();
      },
    },
  },

  created() {
    this.retrieve();
  },

  methods: {
    permission,
    moment,
    formatPrice,

    professionalClassCouncilValue,

    retrieve() {
      const { id } = routes.history.current.params;

      this.resident_id = id;

      this.paginate();
    },

    handleDetails(order) {
      this.order = order;
      this.$bvModal.show("details");
    },

    handleEdit(order) {
      this.order = order;
      this.$bvModal.show("edit");
    },

    handlePrint({ id }) {
      let route = this.$router.resolve({
        name: "resident-order-print",
        params: {
          id,
        },
      });

      window.open(route.href, "_blank");
    },

    handleFilter() {
      this.options.page = 1;
      this.paginate();
    },

    async paginate() {
      try {
        this.loading = true;

        let { resident_id, status } = this;

        const { page, itemsPerPage } = this.options;

        let params = {
          resident_id,
          page,
          itemsPerPage,
          status,
        };

        const response = await api.get("/rest-home/resident/orders", {
          params,
        });

        const { error, errors, data, total } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.data = data;
          this.total = total;
          this.$bvModal.hide("filter");
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async deleteOrder(id) {
      try {
        this.loadingDelete = true;

        let data = { id };

        let response = await api.delete("/rest-home/resident/order", {
          data,
        });

        let { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          toast(message, "success");
          this.paginate();
        }

        this.loadingDelete = false;
      } catch (error) {
        this.loadingDelete = false;
        console.log(error);
      }
    },
  },
};
</script>
